module.exports = __webpack_public_path__ + "img/meliina_raty.40ee70c7.jpeg";